import { render, staticRenderFns } from "./CcrisSupplementary.vue?vue&type=template&id=5fca6beb&scoped=true"
import script from "./CcrisSupplementary.vue?vue&type=script&lang=js"
export * from "./CcrisSupplementary.vue?vue&type=script&lang=js"
import style0 from "./CcrisSupplementary.vue?vue&type=style&index=0&id=5fca6beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca6beb",
  null
  
)

export default component.exports